import React from 'react'
import {
  Select,
  MenuItem,
  Tooltip,
  Typography,
  CircularProgress,
} from '@material-ui/core'
import ShareIcon from '@material-ui/icons/Share'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { FormattedMessage } from 'react-intl'
import { copyToClipboard } from 'libs/clipboard'
import Assets from 'app/configs/assetConfigs'
import { useShareNotification } from 'app/components/notificationCard/useShareNotification'
import { FuseAnimateGroup } from '@fuse'
import Loader from 'app/components/Loader'
import { useFlag } from '@unleash/proxy-client-react'

const useStyles = makeStyles((theme) => ({
  darkGreyText: {
    color: theme.palette.darkGrey.main,
  },
  selectIcon: {
    display: 'none',
  },
}))

const ShareButton = ({
  scheduleDate,
  notificationId,
  onCopySucceed,
  onCopyFailure,
  scheduleDateAndTimeZone,
}) => {
  const { publicLinks, isSharingDisabled, fetchPublicLinks, isLoading } =
    useShareNotification(notificationId, scheduleDate)

  const classes = useStyles()

  function conditionTooltip(isShowing, title, component) {
    if (isShowing) {
      return <Tooltip title={title}>{component}</Tooltip>
    } else return component
  }

  return conditionTooltip(
    isSharingDisabled,
    <div className="text-xxs leading-tight">
      <FormattedMessage
        id="notificationTimeline.card.publicLink.shareButton.scheduleTooltip"
        values={{ ...scheduleDateAndTimeZone }}
      />
    </div>,
    <Select
      name="publicLink"
      disabled={isSharingDisabled}
      disableUnderline={true}
      className={clsx(classes.darkGreyText, 'pt-8 mb-8 text-xs font-bold')}
      onOpen={fetchPublicLinks}
      onChange={(event) => {
        if (event.target.value) {
          copyToClipboard(event.target.value)
            .then(onCopySucceed)
            .catch(onCopyFailure)
        }
      }}
      displayEmpty
      value=""
      renderValue={(value) => (
        <div className="flex items-center">
          <ShareIcon style={{ fontSize: '1.5rem' }} className="mr-2" />
          <FormattedMessage id="notificationTimeline.card.publicLink.shareButton.title" />
        </div>
      )}
      inputProps={{
        classes: {
          icon: classes.selectIcon,
        },
      }}
    >
      {isLoading ? (
        <Loader
          timeout={0}
          isLoading={isLoading}
          placeholder={
            <FuseAnimateGroup
              enter={{ animation: 'fadeIn' }}
              leave={{ animation: 'fadeOut' }}
            >
              <div className="w-full h-full flex m-auto justify-center">
                <CircularProgress color="secondary" size={12} />
              </div>
            </FuseAnimateGroup>
          }
        />
      ) : (
        publicLinks.map((publicLinked) => {
          const { id, publicLink, name, nativeName } = publicLinked

          return (
            <MenuItem key={id} value={publicLink}>
              <div className="flex flex-grow">
                <div>
                  <div className="text-14">{nativeName}</div>
                  {name !== 'English' && (
                    <div className="text-12 font-semibold">{name}</div>
                  )}
                </div>
              </div>
              <div className="flex ltr:pl-16 rtl:pr-16">
                <img
                  width="14"
                  className={clsx('text-xs', classes.darkGreyText)}
                  src={Assets.copyIcon}
                  alt="copyIcon"
                />
              </div>
            </MenuItem>
          )
        })
      )}
    </Select>,
  )
}
export default ShareButton
